import { Phone, Instagram, Facebook, Youtube } from "lucide-react";
import { NAV_LINKS, CONTACT } from "@/lib/data";
import { Logo, scrollToId } from "@/components/Logo";

export default function Footer() {
  return (
    <footer
      className="relative bg-[var(--footer)] text-[var(--bg)] grain overflow-hidden"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="inline-flex items-center rounded-xl bg-[var(--bg)] px-6 py-4">
              <Logo className="h-12 w-auto" />
            </div>
            <p className="mt-6 font-serif text-3xl sm:text-4xl leading-[1.15] max-w-md text-[var(--bg)]/90">
              Architects of unforgettable sacred celebrations.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <div className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] mb-5">Explore</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => scrollToId(l.href)}
                    className="link-underline text-[var(--bg)]/75 hover:text-[var(--bg)] transition-colors text-sm"
                    data-testid={`footer-link-${l.href}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] mb-5">Get in touch</div>
            <a
              href={`tel:${CONTACT.phone}`}
              className="flex items-center gap-2 font-serif text-2xl hover:text-[var(--gold)] transition-colors"
              data-testid="footer-phone"
            >
              <Phone size={18} /> {CONTACT.phoneDisplay}
            </a>
            <p className="mt-3 text-sm text-[var(--bg)]/70">{CONTACT.locationLine}</p>
            <a
              href={`https://wa.me/${CONTACT.whatsapp}`}
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex rounded-full border border-[var(--bg)]/25 px-5 py-2.5 text-sm hover:border-[var(--gold)] hover:text-[var(--gold)] transition-colors"
              data-testid="footer-whatsapp"
            >
              Message on WhatsApp
            </a>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="h-11 w-11 rounded-full border border-[var(--bg)]/20 flex items-center justify-center text-[var(--bg)]/80 hover:text-[var(--ink)] hover:bg-[var(--gold)] hover:border-[var(--gold)] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={CONTACT.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="h-11 w-11 rounded-full border border-[var(--bg)]/20 flex items-center justify-center text-[var(--bg)]/80 hover:text-[var(--ink)] hover:bg-[var(--gold)] hover:border-[var(--gold)] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href={CONTACT.youtube}
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
                className="h-11 w-11 rounded-full border border-[var(--bg)]/20 flex items-center justify-center text-[var(--bg)]/80 hover:text-[var(--ink)] hover:bg-[var(--gold)] hover:border-[var(--gold)] transition-colors"
                data-testid="footer-youtube"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[var(--bg)]/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[var(--bg)]/50">
          <span>© {new Date().getFullYear()} Weddings by Temple Bells. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <a href="/admin" className="hover:text-[var(--gold)] transition-colors" data-testid="footer-studio-login">
              Studio Login
            </a>
            <span>Crafted with devotion.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
